import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal } from 'antd';
import styles from "./asset/pageFooter.module.scss";
import prepalLogo from '../../publicAsset/media/Prepal Logo 3.svg';
import facebookIcon from '../../publicAsset/media/Platform=Facebook, Color=Original.svg';

const PageFooter = () => {
    const navigate = useNavigate();
    const currentYear = new Date().getFullYear();

    const footerLinks = {
        faq: [
            { label: 'About Us', path: '/about-us', disabled: false },
            { label: 'Blog', path: '/blog', disabled: true },
            { label: 'Contact Us', path: '/contact', disabled: true },
            { label: 'Pricing', path: '/pricing', disabled: false },
            { label: 'Partner', path: '/partner', disabled: true }
        ],
        support: [
            { label: 'Help center', path: '/help', disabled: true },
            { label: 'Term of service', path: '/terms-of-service', disabled: false },
            { label: 'Refund and Complaint policy', path: '/refund-complaint-policy', disabled: false },
            { label: 'Privacy policy', path: '/privacy-policy', disabled: false },
            { label: 'Cookies Settings', path: '/cookies', disabled: true }
        ]
    };

    const socialLinks = [
        {
            name: 'Facebook',
            url: 'https://www.facebook.com/profile.php?id=61578071474751',
            icon: facebookIcon
        },
        {
            name: 'YouTube',
            url: 'https://youtube.com/@prepal',
            svg: <svg width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M30.7 9.6c-.4-1.4-1.4-2.4-2.8-2.8C25.5 6 16 6 16 6s-9.5 0-11.9.8c-1.4.4-2.4 1.4-2.8 2.8C.5 12 .5 16.9.5 16.9s0 4.9.8 7.3c.4 1.4 1.4 2.4 2.8 2.8 2.4.8 11.9.8 11.9.8s9.5 0 11.9-.8c1.4-.4 2.4-1.4 2.8-2.8.8-2.4.8-7.3.8-7.3s0-4.9-.8-7.3zM13 21.1V12.7l8 4.2-8 4.2z" fill="#FF0000" /></svg>
        }
    ];

    const handleEmailSubmit = (e) => {
        e.preventDefault();
        Modal.info({
            title: 'Coming Soon',
            content: 'This feature will be implemented later',
            centered: true,
        });
    };

    const handleLinkClick = (link) => {
        if (link.disabled) {
            Modal.info({
                title: 'Coming Soon',
                content: 'This feature will be implemented later',
                centered: true,
            });
        } else {
            navigate(link.path);
        }
    };

    return (
        <footer className={styles.footer}>
            <div className={styles.footerContent}>
                {/* Left Section - Logo & CTA */}
                <div className={styles.leftSection}>
                    <img
                        className={styles.logo}
                        src={prepalLogo}
                        alt="Prepal Logo"
                    />

                    <button
                        className={styles.ctaButton}
                        onClick={() => navigate('/sign-up')}
                    >
                        <svg width="24" height="24" viewBox="0 0 20 20" fill="none">
                            <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        <span>Start Now</span>
                    </button>

                    <div className={styles.socialLinks}>
                        {socialLinks.map((social) => (
                            <a
                                key={social.name}
                                href={social.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={styles.socialIcon}
                                aria-label={social.name}
                            >
                                {social.icon ? (
                                    <img src={social.icon} alt={social.name} />
                                ) : (
                                    social.svg
                                )}
                            </a>
                        ))}
                    </div>
                </div>

                {/* Right Section - Links */}
                <div className={styles.rightSection}>
                    {/* FAQ Links */}
                    <div className={styles.linkColumn}>
                        <h3 className={styles.columnTitle}>FAQ</h3>
                        <nav className={styles.linkList}>
                            {footerLinks.faq.map((link) => (
                                <button
                                    key={link.label}
                                    onClick={() => handleLinkClick(link)}
                                    className={`${styles.link} ${link.disabled ? styles.disabled : ''}`}
                                >
                                    {link.label}
                                </button>
                            ))}
                        </nav>
                    </div>

                    {/* Support Links */}
                    <div className={styles.linkColumn}>
                        <h3 className={styles.columnTitle}>Support</h3>
                        <nav className={styles.linkList}>
                            {footerLinks.support.map((link) => (
                                <button
                                    key={link.label}
                                    onClick={() => handleLinkClick(link)}
                                    className={`${styles.link} ${link.disabled ? styles.disabled : ''}`}
                                >
                                    {link.label}
                                </button>
                            ))}
                        </nav>
                    </div>

                    {/* Newsletter */}
                    <div className={styles.linkColumn}>
                        <h3 className={styles.columnTitle}>Keep in touch</h3>
                        <form onSubmit={handleEmailSubmit} className={styles.newsletterForm}>
                            <input
                                type="email"
                                placeholder="Your Email Address"
                                className={styles.emailInput}
                                required
                            />
                            <button type="submit" className={styles.submitButton}>
                                Submit
                            </button>
                        </form>
                    </div>
                </div>
            </div>

            <div className={styles.copyright}>
                © {currentYear}. All rights reserved.
            </div>
        </footer>
    );
};

export default PageFooter;